import { render } from "./Spacing.vue?vue&type=template&id=1e6bce12"
import script from "./Spacing.vue?vue&type=script&lang=ts"
export * from "./Spacing.vue?vue&type=script&lang=ts"
script.render = render

export default script